// extracted by mini-css-extract-plugin
module.exports = {"root":"SvgRender_root__FJ6wY"};